// HomeBanner.js
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./HomeBanner.css";

// 🔹 Custom Arrows
const CustomPrevArrow = ({ onClick }) => (
  <button className="custom-arrow prev-arrow" onClick={onClick}>
    &#8592;
  </button>
);

const CustomNextArrow = ({ onClick }) => (
  <button className="custom-arrow next-arrow" onClick={onClick}>
    &#8594;
  </button>
);

const HomeBanner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  useEffect(() => {
    fetch("https://api.saadmotors.com/get-car-banner.php")
      .then((res) => res.json())
      .then((data) => {
        setBanners(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Banner fetch error:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="text-center py-5">Loading banners...</div>;
  }

  return (
    <div className="home-banner-container mt-3">
      <Slider {...settings}>
        {banners.map((banner, index) => (
          <div className="slider-item" key={index}>
            <img
              src={`https://api.saadmotors.com/${banner.image_path}`}
              alt="Banner"
              className="slider-image"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HomeBanner;